<template>
    <b-modal v-model="modal_toxicity.show"
             centered
             :title="component.name"
    >
        <form @submit.prevent="validateForm()"
              data-vv-scope="component"
        >
            <b-row>
                <b-col md="6">
                    <b-form-group>
                        <label for="dl_50_oral">DL50 Oral <span class="text-black-50 small">(mg/kg)</span></label>
                        <el-input id="dl_50_oral"
                                  name="dl_50_oral"
                                  size="small"
                                  type="text"
                                  v-model="component.toxicity.dl_50_oral"
                                  data-vv-as=" "
                                  v-validate="'decimal:7|min_value:0|max_value:100000'"
                        />
                        <span class="text-danger small"
                              v-text="errors.first('component.dl_50_oral')"
                        />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label for="dl_50_cutaneous">DL50 Cutáneo <span
                            class="text-black-50 small">(mg/kg)</span></label>
                        <el-input id="dl_50_cutaneous"
                                  name="dl_50_cutaneous"
                                  size="small"
                                  type="text"
                                  v-model="component.toxicity.dl_50_cutaneous"
                                  data-vv-as=" "
                                  v-validate="'decimal:7|min_value:0|max_value:100000'"
                        />
                        <span class="text-danger small"
                              v-text="errors.first('component.dl_50_cutaneous')"
                        />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="cl_50_inhalation">CL50 Inhalación</label>
                        <b-row>
                            <b-col>
                                <el-input id="cl_50_inhalation"
                                          name="cl_50_inhalation"
                                          size="small"
                                          type="text"
                                          v-model="component.toxicity.cl_50_inhalation"
                                          data-vv-as=" "
                                          v-validate="'decimal:7|min_value:0|max_value:100000'"
                                          @change="setUnit(component)"
                                />
                                <span class="text-danger small"
                                      v-text="errors.first('component.cl_50_inhalation')"
                                />
                            </b-col>
                            <b-col>
                                <el-select id="sys_measure_unit_cl_50_id"
                                           name="sys_measure_unit_cl_50_id"
                                           v-model="component.toxicity.sys_measure_unit_cl_50_id"
                                           size="small"
                                           clearable
                                           no-data-text="No hay datos que coincidan"
                                           no-match-text="No hay datos que coincidan"
                                           data-vv-as=" "
                                           v-validate="{rules:{required: !!component.toxicity.cl_50_inhalation}}"
                                           disabled
                                >
                                    <el-option v-for="measure_unit in measureUnitsCl50"
                                               :key="measure_unit.id"
                                               :value="measure_unit.id"
                                               :label="measure_unit.lista"
                                    />
                                </el-select>
                                <span class="text-danger small"
                                      v-text="errors.first('component.sys_measure_unit_cl_50_id')"
                                />
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
        </form>

        <template #modal-footer>
            <div class="w-100">
                <b-row>
                    <b-col cols="12"
                           class="text-center"
                    >
                        <b-button @click="validateForm"
                                  variant="primary"
                                  class="mr-1"
                                  size="sm"
                        >
                            <i class="fa fa-save"></i> Guardar
                        </b-button>
                        <b-button @click="setModalToxicityShow(false)"
                                  variant="secondary"
                                  class="ml-1"
                                  size="sm"
                        >
                            <i class="fa fa-close"></i> Cancelar
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </template>

    </b-modal>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';

export default {
    name: 'modal',
    computed: {
        ...mapState('calculator', [
            'modal_toxicity',
            'product',
            'action',
            'manufacturers',
            'component',
            'measure_units_cl_50'
        ]),
        ...mapGetters('calculator', ['measureUnitsCl50'])
    },
    methods: {
        ...mapActions('calculator', [
            'getManufacturers',
            'createProduct',
            'updateToxicitiesComponents',
            'getProduct'
        ]),
        ...mapMutations('calculator', [
            'setModalToxicityShow'
        ]),
        validateForm() {
            this.$validator.validateAll('component')
                .then(async (result) => {
                    if (result) {
                        await this.updateToxicitiesComponents({components: [this.component]});

                        const product_id = this.$route.params.product_id;
                        const company_id = this.$route.params.company_id;

                        if (!!product_id && !!company_id) {
                            this.setModalToxicityShow(false);
                            this.$emit('update');
                        }
                    }
                });
        },
        setUnit(component) {
            if (component.toxicity.cl_50_inhalation) {
                const unit = this.measureUnitsCl50[0];
                component.toxicity.sys_measure_unit_cl_50_id = unit.id;
            } else {
                component.toxicity.sys_measure_unit_cl_50_id = null;
            }
        }
    }
};
</script>

<style scoped>

</style>
